'use client';

import { styled } from '@linaria/react';
import MyTrackDatePicker from '@fe-news/components/molecules/MyTrackDatePicker';
import HotCollectionCard from '@fe-news/components/molecules/RankingListHotCollection/HotCollectionCard';
import HotCollectionCardLazy from '@fe-news/components/molecules/RankingListHotCollection/HotCollectionCardLazy';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import useRankingList from '@fe-news/hooks/use-ranking-list';
import HotCollectionCardSkeleton from '@fe-news/components/molecules/RankingListHotCollection/HotCollectionCardSkeleton';
import { useMyTrackDate } from '@fe-news/context/my-track-date-provider';

// type
import { RankingProductType, MyTrackSelectDate } from '@fe-news/constants/my-track/type';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  position: relative;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #000;
  column-gap: 16px;
`;

const RedBar = styled.div`
  width: 5px;
  height: 22px;
  background-color: #e03f19;
  position: absolute;
  top: 7px;
  left: -25px;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    left: -12px;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const HotCollectionList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

type RankingListHotCollectionProps = {
  children: React.ReactNode;
  isRankingList?: boolean;
};

const RankingListHotCollection = ({ children, isRankingList = false }: RankingListHotCollectionProps) => {
  const { data: rankingList, isLoading } = useRankingList({ type: RankingProductType.NEWS });
  const { selectDate } = useMyTrackDate();

  return (
    <Container>
      <RedBar />
      <Title>
        <h3>熱門收藏</h3>
        <MyTrackDatePicker />
      </Title>
      {selectDate === MyTrackSelectDate.RECENT_ONE_MONTH && <> {children}</>}
      {selectDate !== MyTrackSelectDate.RECENT_ONE_MONTH && isLoading && (
        <HotCollectionList>
          {Array.from({ length: 10 }).map((_, index) => (
            <HotCollectionCardSkeleton key={index} />
          ))}
        </HotCollectionList>
      )}
      {selectDate !== MyTrackSelectDate.RECENT_ONE_MONTH && !isLoading && (
        <HotCollectionList>
          {rankingList.map((item, index) => {
            return index < 5 ? (
              <HotCollectionCard
                key={item.productId}
                id={Number(item.productId)}
                hotRate={item.cnt}
                index={index}
                isRankingList={isRankingList}
              />
            ) : (
              <HotCollectionCardLazy
                key={item.productId}
                id={Number(item.productId)}
                hotRate={item.cnt}
                index={index}
                isRankingList={isRankingList}
              />
            );
          })}
        </HotCollectionList>
      )}
    </Container>
  );
};

export default RankingListHotCollection;
